import { useTranslation } from "react-i18next";

export const useDefaultSetPendingTranslations = () => {
  const { t } = useTranslation();

  return {
    title: t("subIBReport_defaultSetPendingTitle", {
      defaultValue: "We’re still getting you set up",
    }),
    lead: t("subIBReport_defaultSetPendingLead", {
      defaultValue: "You can create a new rebate program in a few hours.",
    }),
    help: t("subIBReport_defaultSetPendingHelp", {
      defaultValue:
        "If the issue persists, contact support@pepperstonepartners.com.",
    }),
    manage: t("subIBReport_defaultSetPendingManage", {
      defaultValue: "Manage programs",
    }),
    close: t("subIBReport_defaultSetPendingClose", {
      defaultValue: "Close",
    }),
  };
};
